export var ACTION_TRIGGER_PREFIX = '__impage_action_trigger_';
/** 基础动作触发器 */
export var BaseActionTrigger;
(function (BaseActionTrigger) {
    /** 初始化 */
    BaseActionTrigger["INIT"] = "__impage_action_trigger_init";
    /** 点击 */
    BaseActionTrigger["CLICK"] = "__impage_action_trigger_click";
    /** 鼠标进入 */
    BaseActionTrigger["MOUSE_ENTER"] = "__impage_action_trigger_mouseEnter";
    /** 鼠标离开 */
    BaseActionTrigger["MOUSE_LEAVE"] = "__impage_action_trigger_mouseLeave";
    /** 双击 */
    BaseActionTrigger["DOUBLE_CLICK"] = "__impage_action_trigger_double_click";
    /** 长按 */
    BaseActionTrigger["LONG_PRESS"] = "__impage_action_trigger_long_press";
    /** 出现 */
    BaseActionTrigger["ENTER_VIEW"] = "__impage_action_trigger_enter_view";
    /** 消失 */
    BaseActionTrigger["LEAVE_VIEW"] = "__impage_action_trigger_leave_view";
})(BaseActionTrigger || (BaseActionTrigger = {}));
/** 动作类型 */
export var ActionTypes;
(function (ActionTypes) {
    /** 通用 */
    ActionTypes["COMMON"] = "common";
    /** 业务 */
    ActionTypes["BUSINESS"] = "business";
    /** 组件 */
    ActionTypes["COMPONENT"] = "component";
})(ActionTypes || (ActionTypes = {}));
/** 组件事件监听类型 */
export var ComponentEventListenerTypes;
(function (ComponentEventListenerTypes) {
    /** 初始化 */
    ComponentEventListenerTypes["INIT"] = "afterRender";
    /** 点击 */
    ComponentEventListenerTypes["CLICK"] = "click";
    /** 鼠标进入 */
    ComponentEventListenerTypes["MOUSE_ENTER"] = "mouseEnter";
    /** 鼠标离开 */
    ComponentEventListenerTypes["MOUSE_LEAVE"] = "mouseLeave";
    /** 双击 */
    ComponentEventListenerTypes["DOUBLE_CLICK"] = "doubleClick";
    /** 长按 */
    ComponentEventListenerTypes["LONG_PRESS"] = "longPress";
    /** 出现 */
    ComponentEventListenerTypes["ENTER_VIEW"] = "enterView";
    /** 消失 */
    ComponentEventListenerTypes["LEAVE_VIEW"] = "leaveView";
})(ComponentEventListenerTypes || (ComponentEventListenerTypes = {}));
/** 热区事件监听类型 */
export var HotAreaEventListenerTypes = ComponentEventListenerTypes;
/** 事件监听目标 */
export var EventListenerTarget;
(function (EventListenerTarget) {
    /** 页面 */
    EventListenerTarget["PAGE"] = "page";
    /** 组件 */
    EventListenerTarget["COMPONENT"] = "component";
    /** 热区 */
    EventListenerTarget["HOT_AREA"] = "hotarea";
    /** 插件 */
    EventListenerTarget["PLUGIN"] = "plugin";
    /** 动作 */
    EventListenerTarget["ACTION"] = "action";
})(EventListenerTarget || (EventListenerTarget = {}));
/**
 * @desc Page Events
 */
export var PageEventListenerTypes;
(function (PageEventListenerTypes) {
    PageEventListenerTypes["INIT"] = "afterRender";
    PageEventListenerTypes["CLOSE"] = "close";
})(PageEventListenerTypes || (PageEventListenerTypes = {}));
/** Plugin Events */
export var PluginEventListenerTypes;
(function (PluginEventListenerTypes) {
    PluginEventListenerTypes["EXEC"] = "exec";
})(PluginEventListenerTypes || (PluginEventListenerTypes = {}));
/** Action Events */
export var ActionEventListenerTypes;
(function (ActionEventListenerTypes) {
    ActionEventListenerTypes["EXEC"] = "exec";
})(ActionEventListenerTypes || (ActionEventListenerTypes = {}));
//# sourceMappingURL=event.js.map